// extracted by mini-css-extract-plugin
export default {"root":"PageBuilderTabItem-module-root-34h"};